'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEnvelope$002dDetail$002dPage$0024 from "./presto.-Envelope-Detail-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024105 from "./presto.-Presto-Router$$anon$105.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dId$0024 from "./presto.types$-Envelope-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$104() {
  this.bdy = null;
  this.bdq = null;
  this.bdr = false;
  this.bdz = null;
  this.bdA = false;
  this.bdD = null;
  this.bdw = null;
  this.bdx = false;
  this.bds = null;
  this.bdt = false;
  this.bdu = null;
  this.bdv = false;
  this.bdB = false;
  this.bdC = false;
  this.bdy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdD = "EnvelopeDetailPage";
}
export { $c_Lpresto_PrestoRouter$$anon$104 as $c_Lpresto_PrestoRouter$$anon$104 };
$p = $c_Lpresto_PrestoRouter$$anon$104.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$104;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$104() {
}
export { $h_Lpresto_PrestoRouter$$anon$104 as $h_Lpresto_PrestoRouter$$anon$104 };
$h_Lpresto_PrestoRouter$$anon$104.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bdy;
});
$p.L = (function() {
  if ((!this.bdr)) {
    this.bdq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdr = true;
  }
  return this.bdq;
});
$p.O = (function() {
  if ((!this.bdA)) {
    this.bdz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdA = true;
  }
  return this.bdz;
});
$p.E = (function() {
  return this.bdD;
});
$p.t = (function() {
  if ((!this.bdx)) {
    this.bdw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdx = true;
  }
  return this.bdw;
});
$p.M = (function() {
  if ((!this.bdt)) {
    this.bds = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dId$0024.$m_Lpresto_types$EnvelopeId$().v7(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdt = true;
  }
  return this.bds;
});
$p.Q = (function() {
  if ((!this.bdv)) {
    this.bdu = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024105.$c_Lpresto_PrestoRouter$$anon$105();
    this.bdv = true;
  }
  return this.bdu;
});
$p.w = (function() {
  if ((!this.bdC)) {
    this.bdB = false;
    this.bdC = true;
  }
  return this.bdB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee628) => ((p) => \u03b4scrutinee628.cG7(p)))($j_presto$002e$002dEnvelope$002dDetail$002dPage$0024.$m_Lpresto_EnvelopeDetailPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$104 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$104, "presto.PrestoRouter$$anon$104", ({
  Ns: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$104 as $d_Lpresto_PrestoRouter$$anon$104 };
//# sourceMappingURL=presto.-Presto-Router$$anon$104.js.map
